export { default } from './FavoritesBar';
